import Search from '@/src/components/Antd/Search/Search';
import { useSelectRows } from '@/src/tools/hooks/listPageHooks';
import { get } from 'lodash';
import React from 'react';
import { useHistory, useParams } from 'react-router';
import { Tag } from 'src/components/Antd';
import ModalHoc from 'src/constrains/ModalHOC';
import Trigger from 'src/constrains/Query1/Filter/DropDown/Trigger';
import { useI18n } from 'src/hooks/useRouterChange';
import { CustomerListCommonContext } from 'src/pages/CustomerDatabaseConfig/CustomerList';
import { EType } from 'src/pages/CustomerDatabaseConfig/CustomerList/tools';
import { addTags, listSearch } from 'src/request/customer/list';
import { defaultPageSize } from 'src/tools/constant';
import { useAfterDidMountEffect } from 'src/tools/customHooks';
import { isUserValid, storeResourceNameGenerator } from 'src/tools/getUserInfo';
import { msg } from 'src/tools/message';
import { i18nGet } from 'src/tools/tools';
import { EDeletionType, ESort } from 'src/types/common';
import {
  EPermissionSource,
  EnumCategory,
  EnumOperation,
  EnumSubCategory,
} from 'src/types/common/resources';
import Filter from '../AdvancedFilter';
import { useCols } from '../tools';
import AddTags from './AddTags';
import GlobalTable from './BulkEditorTable2';
import css from './css.module.less';
import { ETagType } from 'src/types/common/customerDb';

const canAddTag = isUserValid({
  source: EPermissionSource.store,
  resourcesGroup: [
    storeResourceNameGenerator({
      category: EnumCategory.Customers,
      subCategory: EnumSubCategory.CustomerTagGeneral,
      operation: EnumOperation.add_tag,
    }),
  ],
});
// const orderDict: any = {
//   descend: 'desc',
//   ascend: 'asc',
// };
const CommonTable = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);
  const h = useHistory();
  const { filterOptions, setExportConfig } = React.useContext(
    CustomerListCommonContext,
  );

  const {
    reportingCurrencyCode,
    salesChannels,
    consentAttributes,
    availableTags,
    availablePromotions,
    availableLanguages,
    salesChannelTacList,
  } = filterOptions;
  const { tabName, id, filters, modalOp, iniTag, disabled } = props;
  const { setShowModal, setModalTitle, setModalContent, onModalCancel } =
    modalOp;
  const _tag = React.useMemo(() => {
    if (tabName === EType.New) {
      return (
        <Tag color='#eeeeee' visible className={css.searchList}>
          {getI18n('customerList.commontable.orders0')}
        </Tag>
      );
    }
    if (tabName === EType.Returning) {
      return (
        <Tag color='#eeeeee' visible className={css.searchList}>
          {getI18n('customerList.commontable.orders1')}
        </Tag>
      );
    }
    if (tabName === EType.AbandonedCheckout) {
      return (
        <Tag color='#eeeeee' visible className={css.searchList}>
          {getI18n('customerList.commontable.abandoned')}
        </Tag>
      );
    }
  }, [tabName]);
  const defaultCol = React.useRef<any>([]);
  const [filter, setFilter] = React.useState({});
  const [filterDisplay, setFilterDisplay] = React.useState(false);
  const [search, setSearch] = React.useState('');
  /* 分页 */
  const [current, setCurrent] = React.useState(0);
  const [total, setTotal] = React.useState(0);
  const [pageSize, setPageSize] = React.useState(defaultPageSize);
  const [, setLoading] = React.useState(true);
  const paginationProps = {
    defaultPageSize: pageSize,
    showQuickJumper: true,
  };

  const { customerDatabaseUuid }: any = useParams();
  const [loaded, setLoaded] = React.useState(false);
  const [columns, setColumns] = React.useState([]);
  //console.log('columns', columns);
  //   const [sort, setSort] = React.useState({});
  const [data, setData] = React.useState([]);
  // const filtersGenerator = () => {
  //   return { filters: { tabName } };
  // };

  const filtersGenerator = React.useMemo(() => {
    const hasSort = columns.find((i) => i.sortOrder);
    const sortBy: any = {};
    if (hasSort) {
      const { key, sortOrder } = hasSort;
      if (sortOrder === ESort.asc) {
        sortBy.field = key;
        sortBy.asc = true;
      } else {
        sortBy.field = key;
        sortBy.asc = false;
      }
    }

    return {
      filters: {
        sortBy, //: { field: 'FirstName', asc: true },
        searchText: search,
        tabName,
        ...filter,
      },
      customerDatabaseUuid,
      //  sortBy,
    };
  }, [columns, filter, search, tabName]);
  const constants = {
    ...(filtersGenerator || {}),
    firstRow: current * pageSize,
    countPerPage: pageSize,
  };
  const getData = () => {
    setLoading(true);
    return listSearch(customerDatabaseUuid, constants)
      .then((res) => {
        const data = get(res, 'customers.results') || [];
        const totalCount = get(res, 'customers.totalCount') || 0;
        setData(data);
        // console.log('res', res);
        setTotal(totalCount);
      })
      .then(() => {
        setLoaded(true);
        setLoading(false);
      });
  };
  const {
    rowSelection,
    selectedRowKeys,
    selectedAll,
    setSelectedAll,
    // setMappedSelectedKeys,
    // //mappedSelectedKeys,
    // setSelectedRowKeys,
  } = useSelectRows(data);

  const currentUuids = React.useMemo(() => {
    return data.map((i) => i.uuid);
  }, [data]);

  React.useEffect(() => {
    if (setExportConfig) {
      setExportConfig({
        selectAll: selectedAll,
        currentPageUuids: currentUuids,
        selectedUuids: selectedRowKeys,
      });
    }
  }, [selectedRowKeys, selectedAll, currentUuids]);

  // const clearTableState = () => {
  //   setSelectedRowKeys([]);
  //   setMappedSelectedKeys([]);
  //   setSelectedAll(false);
  // };
  const handleOnSortChange = (pagination, filters, sorter, extra) => {
    const { columnKey, order } = sorter;
    const _col = columns.map((i) => {
      const re = { ...i };
      if (re.key === columnKey) {
        re.sortOrder = order;
      } else {
        re.sortOrder = '';
      }
      return re;
    });
    //console.log(_col);

    setColumns(_col);
  };

  React.useEffect(() => {
    if (!disabled) {
      listSearch(customerDatabaseUuid, constants)
        .then((res) => {
          const f = get(res, 'customerLayout.fields') || [];
          //  console.log(JSON.stringify(f));
          const onView = (uuid) => {
            h.push(
              `/customerDatabase/customerDetail/${customerDatabaseUuid}/${uuid}`,
            );
          };
          const col = useCols(f, onView, { getI18n });
          //        console.log('col', col);
          //console.log(col);
          setColumns(col);
          defaultCol.current = col;
          //const data = get(res, 'customers.results') || [];
          // setData(data);
          const total = get(res, 'customers.totalCount') || 0;
          setTotal(total);
          setLoading(false);
          //console.log(res);
        })
        .then(() => {
          setLoaded(true);
        });
    } else {
      setLoaded(true);
    }
  }, []);

  useAfterDidMountEffect(() => {
    // console.log(11);
    if (!disabled) {
      getData();
    }
  }, [current]);

  useAfterDidMountEffect(() => {
    if (!disabled) {
      if (!current) {
        getData();
      } else {
        setCurrent(0);
      }
    }
  }, [pageSize, filtersGenerator]);

  const buttonMenu = canAddTag
    ? [
        //Bulk Edit
        {
          key: 1,
          value: getI18n('customerList.commontable.addTag'),
          function: () => {
            if (selectedRowKeys.length > 0) {
              setShowModal(true);
              setModalContent(
                <AddTags
                  options={availableTags.filter(
                    (i) => i.tagType === ETagType.Manual,
                  )}
                  onCancel={onModalCancel}
                  onOk={(tags) => {
                    const params = {
                      customerUuids: selectedRowKeys || [],
                      selectionType: selectedAll
                        ? EDeletionType.All
                        : EDeletionType.Selected,
                      manualTagUuids: tags,
                    };

                    addTags(params).then(() => {
                      msg.success(getI18n('customerList.commontable.msg.succ'));
                      onModalCancel();
                    });
                  }}
                />,
              );
              setModalTitle(getI18n('customerList.commontable.addTag'));
            }
          },
        },
      ]
    : [];

  return (
    <React.Fragment>
      {disabled ? null : (
        <React.Fragment>
          <Filter
            iniTag={iniTag}
            display={filterDisplay}
            setDisplay={setFilterDisplay}
            onConfirm={setFilter}
            filterList={filters}
            fieldsData={{
              currency: reportingCurrencyCode,
              salesChannels,
              consentAttributes,
              availableTags,
              availablePromotions,
              availableLanguages,
              salesChannelTacList,
            }}
          />
          <div className={css.topWrapper}>
            <div className={css.topContainer}>
              <Search
                enterButton={getI18n('customerList.commontable.search')}
                onSearch={setSearch}
                allowClear
                placeholder={getI18n('customerList.commontable.placeholder')}
                formClassName={css.search}
              />
              <div className={css.filterText}>
                {getI18n('general.filterGroup.filter')}
              </div>
              <Trigger
                name={getI18n('customerList.commontable.allFilters')}
                hideArrow
                className={css.allFilterTriggers}
                onClick={() => setFilterDisplay(true)}
              />
            </div>
            {_tag}
          </div>
        </React.Fragment>
      )}
      {loaded && (
        <GlobalTable
          onColChange={setColumns}
          id={id}
          showSorterTooltip={false}
          onChange={handleOnSortChange}
          hideQuery
          dataSource={data}
          columns={columns}
          selectedAll={selectedAll}
          setSelectedAll={setSelectedAll}
          buttonMenu={buttonMenu}
          rowKey='uuid'
          pagination={paginationProps}
          current={current}
          setCurrent={setCurrent}
          pageSize={pageSize}
          setPageSize={setPageSize}
          total={total}
          rowSelection={rowSelection}
          selectedRowKeys={selectedRowKeys}
          // mappedSelectedKeys={mappedSelectedKeys}
          hidePagination={total == 0}
          loading={!loaded}
          className={css.table123}
          defaultCol={defaultCol.current}
          // handleTableSettingChange={handleTableSettingChange}
          // tableSettings={tableSettings}
        />
      )}
    </React.Fragment>
  );
};
export default ModalHoc(CommonTable);
